export default __webpack_public_path__ + "static/media/google.53bcee19.svg";